<template>
  <unsupported-page class="not-enough-memory">
    <template v-slot:title>
      Hey! Your device doesn’t have enough available memory to run Serato Visualizer. <br>
      Try closing any unnecessary browser tabs and apps where possible.
    </template>
    <template v-slot:body>
      <p class="not-enough-memory__body">If this issue persists, <a>contact support.</a></p>
    </template>
  </unsupported-page>
</template>
<script setup lang="ts">
import UnsupportedPage from '@/components/unsupported-pages/UnsupportedPage.vue'
import GtmHelper from '@/analytics/gtm-helper'

GtmHelper.getInstance().triggerNotEnoughMemoryEvent()

</script>
<style lang="scss">
.not-enough-memory {
  &__body {
    color: $white;
    font-size: 20px;
    font-family: $font-light;

    a {
      color: $link-blue;
      text-decoration: none;
      font-weight: 400;
    }
  }
}
</style>>
  